import { get, del, post, put } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const getMerchantPermissionByUserName = (record) => post(url.MERCHANT_PERMISSION_GET, record)
export const getSubMerchantIdByUserName = (record) => post(url.MERCHANT_SUBMERCHANTID_GET, record)
export const getMerchantPermissionByMerchantId = (record) => post(url.MERCHANT_PERMISSION_BYMERCHANTID_GET, record)


